import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { Observer, observer } from "mobx-react-lite";
import DistributorsViewModel from "../../../viewModels/timeCharges/distributors/distributorsViewModel";

const DistributorsView: ViewComponent<DistributorsViewModel> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(DistributorsView, DistributorsViewModel);
